
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconErrorcard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 22)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65.781 3.977C62 2.705 62.23 3.157 31.51 3.157a11.596 11.596 0 0 0-10.788 7.497L18.6 16.368H4.934C2.209 16.368 0 18.586 0 21.322v29.724C0 53.782 2.209 56 4.934 56H54.27c2.724 0 4.933-2.218 4.933-4.954v-9.99a18.034 18.034 0 0 0 6.578-1.933c.242-23.354.242-35.07 0-35.146zm-9.867 42.115v4.954c0 .912-.736 1.652-1.644 1.652H4.934c-.909 0-1.645-.74-1.645-1.652v-4.954h52.625zm-18.09-33.027v3.303H22.103l1.644-4.558a8.224 8.224 0 0 1 7.762-5.35c33.187 0 29.602-.347 34.272 1.189v27.643a14.468 14.468 0 0 1-6.578 2.428V21.322c0-2.736-2.209-4.954-4.933-4.954h-3.29c-.908 0-1.644.74-1.644 1.651v3.303c0 6.341-8.223 8.389-8.223 4.954v-13.21c0-.913-.736-1.652-1.644-1.652-.908 0-1.645.74-1.645 1.651zm18.09 29.724H3.29V21.322c0-.912.736-1.651 1.645-1.651h32.89v6.605c0 8.389 14.801 5.648 14.801-4.954v-1.651h1.645c.908 0 1.644.739 1.644 1.651v21.467z",
  fill: "#000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "var(--theme-primary, #810ea9)",
  x: 65.769,
  width: 13.23,
  height: 42.445,
  rx: 1.641
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.738 24.92a6.482 6.482 0 0 0-7.222-1.865c-2.556.966-4.25 3.436-4.25 6.198 0 2.761 1.694 5.232 4.25 6.197a6.482 6.482 0 0 0 7.222-1.864 6.482 6.482 0 0 0 7.221 1.864c2.556-.965 4.25-3.436 4.25-6.197 0-2.762-1.694-5.232-4.25-6.198a6.482 6.482 0 0 0-7.221 1.865zM9.57 29.253c0-1.827 1.462-3.308 3.267-3.308 1.804 0 3.267 1.481 3.267 3.308 0 1.827-1.463 3.307-3.267 3.307-1.805 0-3.267-1.48-3.267-3.307zm13.068 3.307c-1.804 0-3.267-1.48-3.267-3.307s1.463-3.308 3.267-3.308c1.805 0 3.267 1.481 3.267 3.308 0 1.827-1.462 3.307-3.267 3.307z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}))));

      const __svgRaw = "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g transform=\"translate(11 22)\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M65.781 3.977C62 2.705 62.23 3.157 31.51 3.157a11.596 11.596 0 0 0-10.788 7.497L18.6 16.368H4.934C2.209 16.368 0 18.586 0 21.322v29.724C0 53.782 2.209 56 4.934 56H54.27c2.724 0 4.933-2.218 4.933-4.954v-9.99a18.034 18.034 0 0 0 6.578-1.933c.242-23.354.242-35.07 0-35.146zm-9.867 42.115v4.954c0 .912-.736 1.652-1.644 1.652H4.934c-.909 0-1.645-.74-1.645-1.652v-4.954h52.625zm-18.09-33.027v3.303H22.103l1.644-4.558a8.224 8.224 0 0 1 7.762-5.35c33.187 0 29.602-.347 34.272 1.189v27.643a14.468 14.468 0 0 1-6.578 2.428V21.322c0-2.736-2.209-4.954-4.933-4.954h-3.29c-.908 0-1.644.74-1.644 1.651v3.303c0 6.341-8.223 8.389-8.223 4.954v-13.21c0-.913-.736-1.652-1.644-1.652-.908 0-1.645.74-1.645 1.651zm18.09 29.724H3.29V21.322c0-.912.736-1.651 1.645-1.651h32.89v6.605c0 8.389 14.801 5.648 14.801-4.954v-1.651h1.645c.908 0 1.644.739 1.644 1.651v21.467z\" fill=\"#000000\" fill-rule=\"nonzero\"/>\r\n        <rect fill=\"var(--theme-primary, #810ea9)\" x=\"65.769\" width=\"13.23\" height=\"42.445\" rx=\"1.641\"/>\r\n        <path d=\"M17.738 24.92a6.482 6.482 0 0 0-7.222-1.865c-2.556.966-4.25 3.436-4.25 6.198 0 2.761 1.694 5.232 4.25 6.197a6.482 6.482 0 0 0 7.222-1.864 6.482 6.482 0 0 0 7.221 1.864c2.556-.965 4.25-3.436 4.25-6.197 0-2.762-1.694-5.232-4.25-6.198a6.482 6.482 0 0 0-7.221 1.865zM9.57 29.253c0-1.827 1.462-3.308 3.267-3.308 1.804 0 3.267 1.481 3.267 3.308 0 1.827-1.463 3.307-3.267 3.307-1.805 0-3.267-1.48-3.267-3.307zm13.068 3.307c-1.804 0-3.267-1.48-3.267-3.307s1.463-3.308 3.267-3.308c1.805 0 3.267 1.481 3.267 3.308 0 1.827-1.462 3.307-3.267 3.307z\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n    </g>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-errorcard.f560e178bcbb0b1b76da587ea85dc5c8.svg"),
        {
          React: SvgIconErrorcard,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      